import styled from "styled-components/macro";
import React, { useEffect, useRef, useState } from "react";
import {
  MdArrowBackIosNew,
  MdArrowForwardIos,
  MdBookmark,
  MdBookmarkBorder,
  MdMenu,
  MdOutlineShoppingCart,
  MdPause,
  MdPerson,
  MdPersonOutline,
  MdPlayArrow,
  MdShoppingCart,
} from "react-icons/md";

import "../styles/Product.css";
import { isEmpty } from "../functions/isEmpty";
import { useLocation, useNavigate, useParams } from "react-router";
import VideoRecorder from "../components/VideoRecorder";
import AdTemplateFlyer from "../components/AdTemplateFlyer";
import Spinner from "../components/CTA/Spinner";
import AdTemplateExpose from "../components/AdTemplateExpose";
import { getEuroCentToEuro } from "../functions/getEuroCentToEuro";

export default function Product({
  isMobile,
  apiURL,
  authToken,
  creators,
  services,
  order,
  setOrder,
  companyData,
}) {
  let navigate = useNavigate();
  let location = useLocation().pathname;
  const { productid } = useParams();

  /* input Data */
  const [companyName, setCompanyName] = useState("");
  const [companyWebsite, setCompanyWebsite] = useState("");
  const [companyColor, setCompanyColor] = useState("grey");
  const [companyPhone, setcompanyPhone] = useState("");
  const [exposeTitle, setExposeTitle] = useState("");
  const [exposeDescription, setExposeDescription] = useState("");
  const [uploadedImgFileURL, setUploadedImgFileURL] = useState("");
  const [openCustomize, setOpenCustomize] = useState(false);

  /* video play data */
  const [serviceData, setServiceData] = useState({ video_url: "", title: "" });
  const [mediaImageURL, setMediaImageURL] = useState(
    "https://www.developercloud.letsfluence.com/api/images/placeholder/profilbildplaceholder.jpg"
  );
  const [imageUploads, setImageUploads] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [videoIndex, setVideoIndex] = useState(0);
  const videoRef = useRef(null); // Reference to the video element
  const [isPlaying, setIsPlaying] = useState(true); // State to track play/pause

  useEffect(() => {
    if (!isEmpty(services)) {
      services.map((service) => {
        if (service.id == productid) {
          setServiceData(service);
          if (service.template_schema_id == 2) {
            setMediaImageURL(
              "https://www.developercloud.letsfluence.com/api/images/placeholder/wohnungsexpose.jpg"
            );
          }
        }
      });
    }
  }, [services, companyData]);

  const replaceMp4WithImg = (inputString) => {
    if (inputString.endsWith(".mp4")) {
      return inputString.replace(/\.mp4$/, "-img.jpg");
    }
    return inputString; // Return the original string if it doesn't end with .mp4
  };

  const nextVideo = () => {
    if (videoIndex == 1) {
      setVideoIndex(0);
    } else {
      setVideoIndex(1);
    }
  };

  const togglePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
        setIsPlaying(false); // Update play state
      } else {
        videoRef.current.play();
        setIsPlaying(true); // Update play state
      }
    }
  };

  const insertLocalImage = (e) => {
    if (e.target.files.length !== 0) {
      let file = e.target.files[0];
      let filetype = "image";
      let newArray = [];
      imageUploads.map((imgObj) => newArray.push(imgObj));
      newArray.push({
        localURL: URL.createObjectURL(file),
        files: file,
        filetype: filetype,
      });
      setImageUploads(newArray);
      setMediaImageURL(URL.createObjectURL(file));
    } else {
      return;
    }

    return;
  };

  const uploadNewVideoFile = async (imgURL) => {
    const resa = await fetch(`${apiURL}/api/images/createoverlayvideo.php`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authToken?.JWT}`,
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: JSON.stringify({
        videourl: serviceData.video_url,
        companyname: companyName,
        companywebsite: companyWebsite,
        imgurl: imgURL,
        colorBackground: companyColor,
      }),
    });

    await resa.text().then((value) => uploadEnds(value));
  };

  const uploadEnds = (value) => {
    console.log(value);
    setIsLoading(false);
  };

  const createAnOrderObject = () => {
    let orderObject = {
      seller_id: serviceData.company_id,
      seller_name: serviceData.company_name,
      seller_pic: serviceData.company_profile_pic,
      seller_price: serviceData.company_price,

      buyer_id: "2",
      buyer_name: "John",
      buyer_pic: uploadedImgFileURL,

      input_pic: uploadedImgFileURL,
      input_companyname: companyName,
      input_companywebsite: companyWebsite,
      input_companycolor: companyColor,
      input_companyphone: companyPhone,
      input_exposeTitle: exposeTitle,
      input_exposeDescription: exposeDescription,

      service_id: serviceData.id,
      service_template_schema_id: serviceData.template_schema_id,
      service_title: serviceData.title,
      service_video_url: serviceData.video_url,
      service_img_url: replaceMp4WithImg(serviceData.video_url),
    };

    setOrder(orderObject);
    navigate("/checkout");
  };

  useEffect(() => {
    if (!isEmpty(imageUploads) && !isLoading) {
      setIsLoading(true);
      handleUploadForImage();
    }
  }, [imageUploads]);

  const handleUploadForImage = async () => {
    const files = document.getElementById("imgInp").files;
    const formData = new FormData();

    for (let i = 0; i < files.length; i++) {
      let file = files[i];

      formData.append("files[]", file);
    }

    if (files.length != 0 && !isEmpty(imageUploads)) {
      const res = await fetch(`${apiURL}/api/images/process.php`, {
        headers: {
          Authorization: `Bearer ${authToken?.JWT}`,
        },
        method: "POST",
        body: formData,
      });

      await res.text().then((value) => imgUploadEnds(value));
    }
  };

  const imgUploadEnds = async (value) => {
    setUploadedImgFileURL(value);
    setIsLoading(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    let element = document.getElementById("videoBackground");
    let colorHex = "";
    if (companyColor == "grey") {
      colorHex = "#7a7a7a";
    } else if (companyColor == "orange") {
      colorHex = "#f58700";
    } else if (companyColor == "blue") {
      colorHex = "#0072f5";
    }
    if (element) {
      // Check if the element exists
      element.style.background = colorHex;
    }
  }, [companyColor, productid, videoIndex]); // Add dependencies

  return (
    <div className="product">
      <div className="product_topnav">
        <div className="product_topnav_back" onClick={() => navigate("/")}>
          <ArrowBack />
        </div>
        <div className="" onClick={() => navigate("/")}>
          {serviceData.title}
        </div>
      </div>

      {isMobile ? (
        <div className="product_topnav">
          <div className="product_topnav_back" onClick={() => navigate("/")}>
            <ArrowBack />
          </div>
          <div className="" onClick={() => navigate("/")}>
            {serviceData.title}
          </div>
        </div>
      ) : (
        <div className="product_topnav">
          <div
            className="product_topnav_left_title"
            onClick={() => navigate("/")}>
            <ArrowBackDesktop />
            {serviceData.title}
          </div>
        </div>
      )}

      <div className="product_body">
        <div className="product_body_video" id={"videoBackground"}>
          <div className="product_body_videoIndexIndicator">
            {videoIndex == 0 ? (
              <>
                <div className="product_body_videoIndexIndicator_elementActive"></div>
                <div className="product_body_videoIndexIndicator_elementInActive"></div>
              </>
            ) : (
              <>
                <div className="product_body_videoIndexIndicator_elementInActive"></div>
                <div className="product_body_videoIndexIndicator_elementActive"></div>
              </>
            )}
          </div>

          <div
            className="product_body_videoPlayButton"
            onClick={() => togglePlayPause()}>
            {isPlaying ? <PauseButtonIcon /> : <PlayButtonIcon />}
          </div>

          <div
            className="product_body_videoNextVideoArea"
            onClick={() => nextVideo()}></div>

          <video
            key={productid + videoIndex} // Add key prop here
            controls={false}
            ref={videoRef}
            preload="metadata"
            id={productid + videoIndex}
            autoPlay={videoIndex == 0 && isPlaying ? true : false}
            playsInline={true}
            muted={false}
            onEnded={() => nextVideo()}
            style={{
              display: 0 === videoIndex ? "block" : "none",
              width: "100%",
              height: "100%",
              borderRadius: "16px",
              objectFit: "cover",
            }}>
            <source
              key={"ahawa"}
              src={!isEmpty(serviceData) ? serviceData.video_url : ""}
              type={`video/mp4`}
            />
            Your browser does not support the video tag.
          </video>
          {videoIndex == 1 && (
            <>
              {serviceData.template_schema_id == 1 && (
                <AdTemplateFlyer
                  imgURL={mediaImageURL}
                  companyName={companyName}
                  companyWebsite={companyWebsite}
                  nextVideo={nextVideo}
                  isPlaying={isPlaying}
                />
              )}
              {serviceData.template_schema_id == 2 && (
                <AdTemplateExpose
                  imgURL={mediaImageURL}
                  exposeTitle={exposeTitle}
                  exposeDescription={exposeDescription}
                  companyName={companyName}
                  companyPhone={companyPhone}
                  nextVideo={nextVideo}
                  isPlaying={isPlaying}
                />
              )}
            </>
          )}
        </div>
        <div className="product_body_customizebar">
          <div className="product_body_customize_title">
            {serviceData.template_schema_id == 1 &&
              "Füge deine Visitenkarte hinzu"}
            {serviceData.template_schema_id == 2 && "Füge dein Exposé hinzu"}
          </div>
          <div className="product_body_customize_text">
            Passe die Werbung an dich an und für{" "}
            {getEuroCentToEuro(serviceData.company_price) + " "}
            wird das Video geteilt
          </div>
          {serviceData.template_schema_id == 1 && (
            <>
              <div className="product_body_desktop_inputbox">
                <div className="product_body_customize_inputbox">
                  <input
                    className="product_body_customize_inputbox_input"
                    placeholder="Firmennamen eingeben"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                  />
                </div>
                <div className="product_body_customize_inputbox">
                  <input
                    className="product_body_customize_inputbox_input"
                    value={companyWebsite}
                    onChange={(e) => setCompanyWebsite(e.target.value)}
                    placeholder="Website eingeben"
                  />
                </div>
              </div>
              <div className="product_body_desktop_inputbox">
                <div className="product_body_customize_inputbox">
                  {isEmpty(imageUploads) && (
                    <label htmlFor={"imgInp"} style={{ width: "100%  " }}>
                      <div className="product_body_customize_inputbox_input">
                        Logo oder persönliches Foto hochladen
                      </div>
                    </label>
                  )}

                  <input
                    type="file"
                    accept=".jpg, .jpeg, .png"
                    id={"imgInp"}
                    name="files[]"
                    placeholder="Website eingeben"
                    className="d-none"
                    onChange={(e) => insertLocalImage(e)}
                  />
                </div>
                <div className="product_body_customize_inputbox">
                  <select
                    value={companyColor}
                    onChange={(e) => setCompanyColor(e.target.value)}
                    className="product_body_customize_selectbox">
                    <option value={"orange"}>Orange</option>
                    <option value={"blue"}>Blau</option>
                    <option value={"grey"}>Grau</option>
                  </select>
                </div>
              </div>
            </>
          )}

          {serviceData.template_schema_id == 2 && (
            <>
              <div className="product_body_desktop_inputbox">
                <div className="product_body_customize_inputbox">
                  <input
                    className="product_body_customize_inputbox_input"
                    placeholder="Überschrift der Wohnung"
                    value={exposeTitle}
                    onChange={(e) => setExposeTitle(e.target.value)}
                  />
                </div>
                <div className="product_body_customize_inputbox">
                  <input
                    className="product_body_customize_inputbox_input"
                    placeholder="Firmennamen eingeben"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                  />
                </div>
              </div>
              <div className="product_body_desktop_inputbox">
                <div className="product_body_customize_inputbox">
                  <input
                    className="product_body_customize_inputbox_input"
                    placeholder="Rufnummer eingeben"
                    value={companyPhone}
                    onChange={(e) => setcompanyPhone(e.target.value)}
                  />
                </div>
                <div className="product_body_customize_inputbox">
                  <input
                    className="product_body_customize_inputbox_input"
                    placeholder="Objektdaten"
                    value={exposeDescription}
                    onChange={(e) => setExposeDescription(e.target.value)}
                  />
                </div>
              </div>

              <div className="product_body_desktop_inputbox">
                <div className="product_body_customize_inputbox">
                  {isEmpty(imageUploads) && (
                    <label htmlFor={"imgInp"} style={{ width: "100%" }}>
                      <div className="product_body_customize_inputbox_input">
                        Titelbild des Objekts hochladen
                      </div>
                    </label>
                  )}

                  <input
                    type="file"
                    accept=".jpg, .jpeg, .png,"
                    id={"imgInp"}
                    name="files[]"
                    placeholder="Bild hochladen"
                    className="d-none"
                    onChange={(e) => insertLocalImage(e)}
                  />
                </div>

                <div className="product_body_customize_inputbox">
                  <select
                    value={companyColor}
                    onChange={(e) => setCompanyColor(e.target.value)}
                    className="product_body_customize_selectbox">
                    <option value={"orange"}>Orange</option>
                    <option value={"blue"}>Blau</option>
                    <option value={"grey"}>Grau</option>
                  </select>
                </div>
              </div>
            </>
          )}

          {isLoading ? (
            <div className="product_body_customize_cta">
              Lädt...
              <Spinner />
            </div>
          ) : (
            <div
              className="product_body_customize_cta"
              onClick={() => createAnOrderObject()}>
              Beauftragen
            </div>
          )}
        </div>

        <div className="product_body_creator">
          <div className="product_body_creator_title">
            Dein Video wird geteilt in der Story {isMobile && <br />}
            von folgendem Kanal:
          </div>
          <div className="product_embededs">
            {!isEmpty(serviceData) &&
              !isEmpty(serviceData.company_insta_accountname) && (
                <div className="product_embededs_element">
                  <iframe
                    className="product_embededs_element_insta"
                    src={
                      "https://www.instagram.com/" +
                      serviceData.company_insta_accountname +
                      "/embed/"
                    }
                    scrolling="no"></iframe>
                </div>
              )}
          </div>
        </div>
      </div>
    </div>
  );
}

/*

  <div className="product_body_bottombar">
        {openCustomize ? (
          <>
            <div
              className="product_body_bottombar_full"
              onClick={() => setOpenCustomize(!openCustomize)}>
              Speichern
            </div>
          </>
        ) : (
          <>
            {isEmpty(companyWebsite) &&
            isEmpty(companyWebsite) &&
            isEmpty(mediaImageURL) ? (
              <>
                <div className="product_body_bottombar_left">Deine Werbung</div>
                <div
                  className="product_body_bottombar_right"
                  onClick={() => setOpenCustomize(!openCustomize)}>
                  Personalisieren
                </div>
              </>
            ) : (
              <>
                <div
                  className="product_body_bottombar_left_editbtn"
                  onClick={() => setOpenCustomize(!openCustomize)}>
                  Personalisieren
                </div>
                {isLoading ? (
                  <div className="product_body_bottombar_right_insta">
                    <Spinner />
                  </div>
                ) : (
                  <div
                    className="product_body_bottombar_right_insta"
                    onClick={() => createAnOrderObject()}>
                    Influencer Auftrag
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>


*/

const MenuIcon = styled(MdMenu)`
  font-size: 30px;
  color: #474747;
`;

const ArrowBack = styled(MdArrowBackIosNew)`
  font-size: 23px;
  color: #474747;
`;

const PlayButtonIcon = styled(MdPlayArrow)`
  font-size: 26px;
  color: #ffffff;
`;

const PauseButtonIcon = styled(MdPause)`
  font-size: 26px;
  color: #ffffff;
`;

const ArrowBackDesktop = styled(MdArrowBackIosNew)`
  font-size: 23px;
  color: #474747;
  margin-bottom: -5px;
  margin-right: 5px;
`;
